import React from 'react';
import { Row } from 'react-bootstrap';
import './styles.scss';
import Typography from '../atoms/typography';

export interface MyProps {
  name: string;
}

const RowHeaderHelp: React.FC<MyProps> = ({ name }: MyProps) => {
  return (
    <Row className="header" noGutters>
      <Typography fontWeight="700" fontSize="default" color="secondary">
        {name}
      </Typography>
      {/* <div style={{ justifyContent: 'flex-end' }}>
        <Typography fontWeight="400" fontSize="default" color="primary">
          Precisa de ajuda?
        </Typography>
      </div> */}
    </Row>
  );
};

export default RowHeaderHelp;
